import React from "react";

export default class Modal extends React.Component<any, any> {
  render() {
    const { id, title, button, children, size = "lg" } = this.props;

    return (
      <div
        id={id}
        className="modal fade react-modal"
        role="dialog"
        tabIndex={-1}
      >
        <div className={`modal-dialog modal-${size} react-modal`}>
          <div className="sn-modal modal-content">
            <div className="modal-header" style={{ padding: "15px" }}>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <h3 style={{ textAlign: "left" }}>
                <strong>{title}</strong>
              </h3>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="sn-btn sn-btn-silver sn-btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
              {button}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
